import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { Verify, Processing, finishVerify } from 'cloak-file-sdk-web';

import { modalStyles } from '../styles/styles'
import * as cloakAnalytics from '../services/cloakAnalytics';
import * as attribution from '../services/attribution';

var modalStyle = modalStyles.singleLineModal


class VerifyPage extends PureComponent {

	 constructor(props){
	 	super(props)
	 	this.state = {
	 		code: '',
	 		codeError: false
	 	}
	 }

	onClick() {
		this.props.dispatch(finishVerify(true))
	}

	componentDidUpdate(prevProps) {
		// Cloak Files signup funnel terminal event: fires once when email
		// verification flips verifiedUser from false → true. The very next
		// thing this component does is <Navigate to="/cloak/login" />.
		if (this.props.verifiedUser && !prevProps.verifiedUser) {
			try {
				const params = new URLSearchParams(window.location.search);
				const plan = params.get('plan') || 'free';
				cloakAnalytics.trackSignupCompleted('cloak_verify', plan);

				// Hand the cloak_attr cookie payload to cloak-file-ws so the
				// marketing distinct_id + UTMs land on the new user's
				// user_acquisition row. Best-effort; runs in parallel with
				// the Navigate redirect.
				const email = params.get('email');
				if (email) {
					attribution.claim(email);
				}
			} catch (e) { /* analytics never blocks verify */ }
		}
	}

	 render() {

		const { status, verify_error, verifyInProcess, verifiedUser, userInfo } = this.props

		console.log("In VerifyPage verifiedUser " + verifiedUser)
	 	if( verifiedUser ) {
			// Gateway/OTP users have no stored password to auto-login with, so send them back to
			// the enterprise login (to re-authenticate with a fresh OTP) rather than the password
			// login page. Detect the gateway flow from the URL (?gwy=true, set when EnterpriseLoginPage
			// redirects here) — robust against the redux userInfo being reset by other login sagas —
			// with userInfo.fromGateway as a fallback. Password users keep the /cloak/login path.
			const fromGatewayUrl = new URLSearchParams(window.location.search).get('gwy') === 'true'
			const isGateway = fromGatewayUrl || (userInfo && userInfo.fromGateway)
			const target = isGateway ? "/cloak/enterprise-login" : "/cloak/login"
	 		return (
				<Navigate to={target} />
			)
	 	}

		if (verifyInProcess && status === null && !verify_error) {
			modalStyle = modalStyles.singleLineModal
		} else {
			modalStyle = modalStyles.doubleLineModal
		}
		console.log("In VerifyPage status " + status)
		console.log("In VerifyPage verify_error " + verify_error)
		console.log("In VerifyPage verifyInProcess " + verifyInProcess)
		const message = (
			<div>
				{(verifyInProcess && status == "svrSuccessResendVerificationEmail") && <FormattedMessage id="signUp.svrSuccessResendVerificationEmail" />}
				{(verifyInProcess && status === null && !verify_error) && <FormattedMessage id="signUp.verificationInProgress" />}
			</div>
		)

		const children = (
			<div>
				{
					(verifyInProcess && status == "svrSuccessResendVerificationEmail") &&
					<div className="clk-modal-button-div">
						<br />
						<button className="clk-modal-button" onClick={() => this.onClick()}>
							<FormattedMessage id="signUp.ok" />
						</button>
					</div>
				}
			</div>
		)

	 	return (
          	<div className="clk-primary-console-div">
				<div className="clk-primary-console clk-box-shadow ">
					<Processing show={ verifyInProcess }
						processing={ verifyInProcess }
						style={ modalStyle }
						message={message}
						children={children} />
					<div style={ { color: '#666', fontSize: '16px', textAlign: 'center', marginTop: 50} }>
						<FormattedMessage id="signUp.userVerification"/>
					</div>
					<Verify />
				</div>
	 		</div>
		)
	}
}

const mapStateToProps = state => {
    return {
		status: state.reg.verify_status,
		verify_error: state.reg.verify_error,
		verifyInProcess: state.reg.verifyInProcess,
		verifiedUser: state.auth.verifiedUser,
		userInfo: state.auth.userInfo
    }
};


export default connect(mapStateToProps)(VerifyPage);
